const testHost = 'pre-api.changyan.com';
const loginRedirectUrl = 'http://localhost:8080';
const audioUrl = 'gtzxx-test.oss-cn-beijing.aliyuncs.com';
export default {
  data () {
    return {
      env_name: ENV_NAME,
      globalConfig: {
        dev: {
          char: ["RZCA", "RWRA"],
          word: ["RCYA", "RWRB", "RSRA"],
          downloadXmlAudioUrl: "http://test.zxx.isay365.com/storage",
          downloadUrl: "http://test.zxx.isay365.com/storage/auth/file?url=",
          downloadPackage:
            "http://test.zxx.isay365.com/cycoreDownload/jkpt/downloadCenter/",
          tssurl: "http://172.31.7.245:8074/tss/",
          apiConfig: {
            appId: "qiming-zxx-platform-xj-test-apply", //测试环境
            appSecret: "9ccee419422360bb", //测试环境
            host: testHost, //测试环境
            httpPort: 80, //HTTP_PORT,
            httpsPort: 443, //HTTPS_PORT,
            stage: "TEST", //STAGE,
            prefixPath: "dev",
            publicKey:
              "305C300D06092A864886F70D0101010500034B0030480241009053DCA70D8CF9E1C5B2906649E2A4C4EDEBBEE28BA6ADCE67CAF8618E84221F59E5A3633445F8CC4CDA694641BCD8FF922E5F2B1954BFB9267836F405FFD4A10203010001",
            staticImageUrl:
              "http://test.zxx.isay365.com/storage/auth/file?url=",
          },
          ssoConfig: {
            version_num: "1.35.0.1265-20210630",
            appName: "edc",
            appKey: "qiming-zxx-platform-xj-test-apply", //测试环境
            client: "web",
            SSOServerUrl: "https://test-open.changyan.com/sso",
            loginRedirectUrl: loginRedirectUrl,
            SSOCenterServerUrl: "https://test-open.changyan.com/sso",
            isCenterSSO: true,
            syncType: 1,
            needAttribute: true,
            _retry: false,
            loginType: {
              LOGINBYNORMAL: "loginByNormal",
              LOGINBYVERIFYCODE: "loginByVerifyCode",
              LOGINBYONLINEAUTO: "loginByOnLineAuto",
              LOGINBYGENERIC: "loginByGeneric",
              LOGINBYTOKEN: "loginByToken",
              LOGINBYCHANGEACCOUNT: "loginByChangeAccount",
              LOGINBYNCET: "loginByNcet",
            },
          },
          mdianConfig: {
            appId: "qm_jkpt_center_plat_sdk",
            host: /127\.0\.0\.1/, //接入SDK的网站的域名,域名匹配监测,参数需要与web应用的域名匹配
            configUrl: "http://logconf.iflytek.com",
            collectUrl: "https://ebglog.iflytek.com",
            source: "ebg",
          },
          aliyunConfig: {
            audioUrl: audioUrl
          }
        },
        test: {
          char: ["RZCA", "RWRA"],
          word: ["RCYA", "RWRB", "RSRA"],
          downloadXmlAudioUrl: "http://test.zxx.isay365.com/storage",
          downloadUrl: "http://test.zxx.isay365.com/storage/auth/file?url=",
          downloadPackage:
            "http://test.zxx.isay365.com/cycoreDownload/jkpt/downloadCenter/",
          tssurl: "http://172.31.7.245:8074/tss/",
          apiConfig: {
            appId: "qiming-zxx-platform-xj-test-apply", //测试环境
            appSecret: "9ccee419422360bb", //测试环境
            host: testHost, //测试环境
            httpPort: 80, //HTTP_PORT,
            httpsPort: 443, //HTTPS_PORT,
            stage: "TEST", //STAGE,
            prefixPath: "test",
            publicKey:
              "305C300D06092A864886F70D0101010500034B0030480241009053DCA70D8CF9E1C5B2906649E2A4C4EDEBBEE28BA6ADCE67CAF8618E84221F59E5A3633445F8CC4CDA694641BCD8FF922E5F2B1954BFB9267836F405FFD4A10203010001",
            staticImageUrl:
              "http://test.zxx.isay365.com/storage/auth/file?url=",
          },
          ssoConfig: {
            version_num: "1.35.0.1265-20210630",
            appName: "edc",
            appKey: "qiming-zxx-platform-xj-test-apply", //测试环境
            client: "web",
            SSOServerUrl: "https://test-open.changyan.com/sso",
            loginRedirectUrl: loginRedirectUrl,
            SSOCenterServerUrl: "https://test-open.changyan.com/sso",
            isCenterSSO: true,
            syncType: 1,
            needAttribute: true,
            _retry: false,
            loginType: {
              LOGINBYNORMAL: "loginByNormal",
              LOGINBYVERIFYCODE: "loginByVerifyCode",
              LOGINBYONLINEAUTO: "loginByOnLineAuto",
              LOGINBYGENERIC: "loginByGeneric",
              LOGINBYTOKEN: "loginByToken",
              LOGINBYCHANGEACCOUNT: "loginByChangeAccount",
              LOGINBYNCET: "loginByNcet",
            },
          },
          mdianConfig: {
            appId: "qm_jkpt_center_plat_sdk",
            host: /127\.0\.0\.1/, //接入SDK的网站的域名,域名匹配监测,参数需要与web应用的域名匹配
            configUrl: "http://logconf.iflytek.com",
            collectUrl: "https://ebglog.iflytek.com",
            source: "ebg",
          },
          aliyunConfig: {
            audioUrl: audioUrl
          }
        },
        testGch: {
          char: ["RZCA", "RWRA"],
          word: ["RCYA", "RWRB", "RSRA"],
          downloadXmlAudioUrl: "http://test.zxx.isay365.com/storage",
          downloadUrl: "http://test.zxx.isay365.com/storage/auth/file?url=",
          downloadPackage:
            "http://test.zxx.isay365.com/cycoreDownload/jkpt/downloadCenter/",
          tssurl: "http://172.31.7.245:8074/tss/",
          apiConfig: {
            appId: "qiming-zxx-platform-xj-test-apply", //测试环境
            appSecret: "9ccee419422360bb", //测试环境
            host: testHost, //测试环境
            httpPort: 80, //HTTP_PORT,
            httpsPort: 443, //HTTPS_PORT,
            stage: "TEST", //STAGE,
            prefixPath: "test/gch",
            publicKey:
              "305C300D06092A864886F70D0101010500034B0030480241009053DCA70D8CF9E1C5B2906649E2A4C4EDEBBEE28BA6ADCE67CAF8618E84221F59E5A3633445F8CC4CDA694641BCD8FF922E5F2B1954BFB9267836F405FFD4A10203010001",
            staticImageUrl:
              "http://test.zxx.isay365.com/storage/auth/file?url=",
          },
          ssoConfig: {
            version_num: "1.35.0.1265-20210630",
            appName: "edc",
            appKey: "qiming-zxx-platform-xj-test-apply", //测试环境
            client: "web",
            SSOServerUrl: "https://test-open.changyan.com/sso",
            loginRedirectUrl: loginRedirectUrl,
            SSOCenterServerUrl: "https://test-open.changyan.com/sso",
            isCenterSSO: true,
            syncType: 1,
            needAttribute: true,
            _retry: false,
            loginType: {
              LOGINBYNORMAL: "loginByNormal",
              LOGINBYVERIFYCODE: "loginByVerifyCode",
              LOGINBYONLINEAUTO: "loginByOnLineAuto",
              LOGINBYGENERIC: "loginByGeneric",
              LOGINBYTOKEN: "loginByToken",
              LOGINBYCHANGEACCOUNT: "loginByChangeAccount",
              LOGINBYNCET: "loginByNcet",
            },
          },
          mdianConfig: {
            appId: "qm_jkpt_center_plat_sdk",
            host: /127\.0\.0\.1/, //接入SDK的网站的域名,域名匹配监测,参数需要与web应用的域名匹配
            configUrl: "http://logconf.iflytek.com",
            collectUrl: "https://ebglog.iflytek.com",
            source: "ebg",
          },
          aliyunConfig: {
            audioUrl: audioUrl
          }
        },
        production: {
          char: ["RZCA", "RWRA"],
          word: ["RCYA", "RWRB", "RSRA"],
          //developmentBak:{
          downloadXmlAudioUrl: "https://zxx-storage.isay365.com/storage",
          downloadUrl: "https://zxx-storage.isay365.com/storage/auth/file?url=",
          downloadPackage:
            "https://zxx-storage.isay365.com/cycoreDownload/jkpt/downloadCenter/",
          tssurl: "http://172.31.7.245:8074/tss/",
          apiConfig: {
            appId: "qiming-zxx-platform-zx-apply",
            appSecret: "bc5992c3c73ed965",
            host: "zxx-api.isay365.com",
            httpPort: 80,
            httpsPort: 443,
            stage: "RELEASE",
            prefixPath: "/pro",
            publicKey:
              "305C300D06092A864886F70D0101010500034B003048024100BCA3303719A6E1F8C9C7E38D96EECE02ADDEAD6BF9220795FB0BC573D103B167D5F8917380E98CD6083B63ABAA00AB60FDB935C2EAE96BDD6288D5B2A7A994E70203010001",
            staticImageUrl:
              "https://zxx-storage.isay365.com/storage/auth/file?url=",
          },
          ssoConfig: {
            version_num: "1.35.0.1265-20210630",
            appName: "edc",
            appKey: "qiming-zxx-platform-zx-apply",
            client: "web",
            SSOServerUrl: "https://open.changyan.com/sso",
            loginRedirectUrl: "http://zxx-web.isay365.com",
            SSOCenterServerUrl: "https://open.changyan.com/sso",
            isCenterSSO: true,
            syncType: 1,
            needAttribute: true,
            _retry: false,
            loginType: {
              LOGINBYNORMAL: "loginByNormal",
              LOGINBYVERIFYCODE: "loginByVerifyCode",
              LOGINBYONLINEAUTO: "loginByOnLineAuto",
              LOGINBYGENERIC: "loginByGeneric",
              LOGINBYTOKEN: "loginByToken",
              LOGINBYCHANGEACCOUNT: "loginByChangeAccount",
              LOGINBYNCET: "loginByNcet",
            },
          },
          mdianConfig: {
            appId: "qm_jkpt_center_plat_sdk",
            host: /127\.0\.0\.1/, //接入SDK的网站的域名,域名匹配监测,参数需要与web应用的域名匹配
            configUrl: "http://logconf.iflytek.com",
            collectUrl: "https://ebglog.iflytek.com",
            source: "ebg",
          },
          aliyunConfig: {
            audioUrl: 'gtzxx-test.oss-cn-beijing.aliyuncs.com'
          }
        },
        productionNM: {
          char: ["RZCA", "RWRA"],
          word: ["RCYA", "RWRB", "RSRA"],
          //developmentBak:{
          downloadXmlAudioUrl: "https://zxx-storage.gty.nmgov.edu.cn/storage",
          downloadUrl: "https://zxx-storage.gty.nmgov.edu.cn/storage/auth/file?url=",
          downloadPackage:
            "https://zxx-storage.gty.nmgov.edu.cn/cycoreDownload/jkpt/downloadCenter/",
          tssurl: "http://172.31.7.245:8074/tss/",
          apiConfig: {

            //appId: "qiming-zxx-platform-nm-apply",
            appId: "qiming-zxx-platform-zx-apply",
            //appSecret: "81FA286E1508A01BB14AC295636C314A",
            appSecret: 'CACCC2D1E6C9BACA91BDCFFFE7690B3F',
            host: 'epasapi.gty.nmgov.edu.cn',
            httpPort: 80,
            httpsPort: 443,
            stage: "RELEASE",
            prefixPath: "/pro",
            // publicKey:
            // "305C300D06092A864886F70D0101010500034B003048024100A3FD21F868063A4181BEA49870E90414C13C48620850AC563FA1FB31E11B0AA05FB5A65C9C54E3B30E23435FBABBC5899AF65D406683E015C5DEF818285C26410203010001"
            publicKey: "305C300D06092A864886F70D0101010500034B0030480241009CC038565E36E34960387CDECC0076370C9F758C49B6A138CCD66597F2B337E1475DB43A7A806C5504228AC0EFBE9A476F9019C45C2524FB89CAB2A8B0EEEE1B0203010001",
            staticImageUrl:
              "https://zxx-storage.gty.nmgov.edu.cn/storage/auth/file?url=",
          },
          ssoConfig: {
            version_num: "1.35.0.1265-20210630",
            appName: "edc",
            appKey: "qiming-zxx-platform-zx-apply",
            //appKey: "qiming-zxx-platform-nm-apply",
            client: "web",
            SSOServerUrl: 'http://gty.nmgov.edu.cn/sso',
            loginRedirectUrl: "http://zxx-web.gty.nmgov.edu.cn",
            SSOCenterServerUrl: "http://gty.nmgov.edu.cn/sso",
            isCenterSSO: true,
            syncType: 1,
            needAttribute: true,
            _retry: false,
            loginType: {
              LOGINBYNORMAL: "loginByNormal",
              LOGINBYVERIFYCODE: "loginByVerifyCode",
              LOGINBYONLINEAUTO: "loginByOnLineAuto",
              LOGINBYGENERIC: "loginByGeneric",
              LOGINBYTOKEN: "loginByToken",
              LOGINBYCHANGEACCOUNT: "loginByChangeAccount",
              LOGINBYNCET: "loginByNcet",
            },
          },
          mdianConfig: {
            appId: "qm_jkpt_center_plat_sdk",
            host: /127\.0\.0\.1/, //接入SDK的网站的域名,域名匹配监测,参数需要与web应用的域名匹配
            configUrl: "http://logconf.iflytek.com",
            collectUrl: "https://ebglog.iflytek.com",
            source: "ebg",
          },
          aliyunConfig: {
            audioUrl: 'zxx-prod.oss-cn-beijing.aliyuncs.com'
          }
        },
      },
    };
  },
  getConfig () {
    let data = this.data();
    if (data.globalConfig.hasOwnProperty(data.env_name)) {
      return data.globalConfig[data.env_name];
    } else {
      return data.globalConfig.dev;
    }
  },
};



// WEBPACK FOOTER //
// ./src/config/config.js